import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  footerform: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.createDataForm();
  }

  createDataForm() {
    this.footerform = this.fb.group({
      email: [null]
    })
  }

  get email() {
    return this.footerform.controls.email as FormControl;
  }

  mapEntity(): void {

  }

  saveData() {

  }

}
